import RaumBackgroundImage from '../static/image/headers-260802/Header-Raum.jpg'
import ContentModule from '../components/ContentModule'
import Container from '../components/Container'
import usePageText from '../hooks/usePageText'
import useStories from '../hooks/useStories'
import useRandom from '../hooks/useRandom'
import Loader from '../components/Loader'
import useStoryFoldStates from '../hooks/useStoryFoldStates'

import Raum1 from '../static/image/raum-neu-1.jpg'
import Raum2 from '../static/image/raum-neu-2.jpg'
import Raum3 from '../static/image/raum-neu-3.jpg'

import Header from '../components/Header'
import useWindowResize from '../hooks/useWindowResize'

const Raum = () => {
  const { pageText, loading: pageTextLoading } = usePageText("ROOM")
  const { stories, loading: storiesLoading } = useStories("ROOM")
  const { storyFoldStates, onModuleFoldStateChanged } = useStoryFoldStates(stories)

  const { seed } = useRandom(5)

  const { isMobile } = useWindowResize()

  const RaumPhotos = [{
  src: Raum1,
  alt: "Foto (1) vom Raum",
}, {
  src: Raum2,
  alt: "Foto (2) vom Raum",
}, {
  src: Raum3,
  alt: "Foto (3) vom Raum",
}]


  return (
    <div>
      <Header bubbleText='Raum' BgImage={RaumBackgroundImage} />

      {
        // Page Text
        <Container>
          <div className={`${isMobile ? "mt-6" : "mt-16"}`}  dangerouslySetInnerHTML={{ __html: pageText }} />
        </Container>
      }

      {
        // STORIES
        <Container className='mt-6' paddingMobile={false}>
          {
            stories.map((story) => {
              return (
                <ContentModule
                  foldState={storyFoldStates?.find(s => s.id === story.id)?.foldState}
                  onFoldStateChanged={(unfold) => onModuleFoldStateChanged(story.id, unfold)}
                  story={story} />
              )
            })
          }
        </Container>
      }

      {
        // Loader
        (pageTextLoading || storiesLoading) && <Loader seed={seed} />
      }

      {
        RaumPhotos.map((photo, index) => (
          <Container key={index} paddingMobile={false}>
            <img alt={photo.alt} src={photo.src} className={`w-full h-auto ${isMobile ? "mt-4" : "mb-24 mt-16 "}`} />
          </Container>
        ))
      }

    </div>
  )
}

export default Raum